export const USER_CURRENT_SESSION_LOADED = 'USER_CURRENT_SESSION_LOADED';
export const CURRENT_USER_LOADED = 'CURRENT_USER_LOADED';
export const USERS_LOADING = 'USERS_LOADING';
export const USERS_LOADED = 'USERS_LOADED';
export const USER_LOADING = 'USER_LOADING';
export const USER_LOADED = 'USER_LOADED';
export const USER_UPDATED = 'USER_UPDATED';
export const USER_ACCOUNTS_LOADING = 'USER_ACCOUNTS_LOADING';
export const USER_ACCOUNTS_LOADED = 'USER_ACCOUNTS_LOADED';
